import { motion } from "framer-motion";
import { Target, FileSearch, LineChart } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Icon3D } from "./Icon3D";

const items = [
  {
    icon: Target,
    title: "Qualificação de risco",
    desc: "Mapeamento técnico de morbidades, sinais de atenção e necessidade de CPT.",
    variant: "deepBlue",
  },
  {
    icon: FileSearch,
    title: "Rastreabilidade",
    desc: "Processo documentado, com videoatendimento gravado e parecer técnico objetivo.",
    variant: "vividBlue",
  },
  {
    icon: LineChart,
    title: "Gestão da carteira",
    desc: "Leitura epidemiológica para apoiar previsibilidade, controle e estratégia assistencial.",
    variant: "aqua",
  },
];

export const PainSolution = () => {
  return (
    <section
      id="dor-solucao"
      data-testid="pain-solution-section"
      className="relative pt-12 md:pt-16 pb-20 md:pb-28"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <SectionHeading
          overline="Por que importa"
          title="Menos subjetividade."
          highlight="Mais segurança na decisão."
          subtitle="Na contratação de planos de saúde, a análise correta das informações declaradas é essencial para reduzir riscos, apoiar decisões técnicas e garantir mais previsibilidade para a carteira."
          testid="pain-solution-heading"
        />

        <div className="mt-14 grid md:grid-cols-3 gap-6 lg:gap-8">
          {items.map((it, idx) => (
            <motion.article
              key={it.title}
              data-testid={`pain-card-${idx}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{
                duration: 0.55,
                ease: [0.16, 1, 0.3, 1],
                delay: idx * 0.08,
              }}
              whileHover={{ y: -6 }}
              className="group bg-white rounded-3xl border border-[#E5EAF2] p-8 md:p-10 shadow-[0_8px_30px_rgba(15,23,42,0.04)] hover:shadow-[0_24px_60px_rgba(53,50,179,0.10)] hover:border-[#3787F5]/30 transition-all duration-300"
            >
              <Icon3D
                icon={it.icon}
                variant={it.variant}
                size="lg"
                className="mb-6 group-hover:scale-110 group-hover:-rotate-3"
              />
              <h3 className="text-xl font-bold text-[#1F2937]">{it.title}</h3>
              <p className="mt-3 text-[#64748B] leading-relaxed">{it.desc}</p>
              <div className="mt-8 h-1 w-12 rounded-full bg-gradient-to-r from-[#3532B3] to-[#12DDB5] opacity-50 group-hover:w-20 transition-all duration-300" />
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
